import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProcurementService } from '../../../../procurement/procurement.service';
import { Material } from '../../../models/material.model';
import { MessageService } from '../../../services/message.service';
import { ConstantsHelper } from '../../../helpers/constants.helper';

@Component({
  standalone: false,
  selector: 'app-add-material',
  templateUrl: './add-material.component.html',
  styleUrls: ['../modal.component.scss']
})

export class AddMaterialComponent implements OnInit {
  materialForm: FormGroup;
  materials: Array<Material> = [];
  unitOptions: Array<string>;
  nextAvailableMaterialId: string;

  @Output() readonly responseChanged = new EventEmitter();

  constructor(private fb: FormBuilder,
              private procurementService: ProcurementService,
              private message: MessageService,
              private constantsHelper: ConstantsHelper) {
    this.unitOptions = this.constantsHelper.getUnitOptions();
  }

  ngOnInit(): void {
    this.materialForm = this.fb.group({
      name: ['', Validators.required],
      unit: ['', Validators.required],
      currentUnitPrice: [null, Validators.required],
      materialId: ['', Validators.required]
    });

    this.getNextAvailableMaterialId();
  }

  getNextAvailableMaterialId(): void {
    this.procurementService.getNextAvailableMaterialId().subscribe(
      res => {
        this.nextAvailableMaterialId = res.results;

        if (this.nextAvailableMaterialId) {
          this.materialForm.get('materialId').setValue(this.nextAvailableMaterialId);
        }
      },
      err => {
        this.message.error(err);
      }
    );
  }

  getMaterialsPricelist(): void {
    this.procurementService.getMaterialsPriceList(0, 50, null, 'true').subscribe(
      res => {
        this.materials = [];

        for (let item of res.results) {
          const material = new Material(item);
          this.materials.push(material);
        }
      },
      err => {
        this.message.error(err);
      }
    );
  }

  emitTrue(): void {
    this.responseChanged.emit(this.materialForm.value);
  }

  emitFalse(): void {
    this.responseChanged.emit(null);
  }
}